import '@fontsource/silkscreen/400.css';
import '@fontsource/silkscreen/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/jetbrains-mono/600.css';
import '@fontsource/jetbrains-mono/700.css';

import DarkIcon from '@material-ui/icons/Brightness2';
import { UnifiedThemeProvider } from '@backstage/theme';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { fbetaTheme } from './fbetaTheme';

const fbetaThemeBlueprint = ThemeBlueprint.make({
  name: 'fbeta',
  params: {
    theme: {
      id: 'fbeta',
      title: 'fbeta',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={fbetaTheme} children={children} />
      ),
    },
  },
});

export const fbetaThemeExtension = createFrontendModule({
  pluginId: 'app',
  extensions: [fbetaThemeBlueprint],
});

export { fbetaThemeColors } from './fbetaTheme';
